<template>
	<div class="height-100dvh" style="overflow-y: auto">
		<div
			class="mob-back-header d-flex justify-content-start align-items-center"
		>
			<div class="mr-3 mb-1" @click="closeDocument()">
				<img src="../../../assets/icons/mobUpldDoc/bck-arrow.svg" />
			</div>
			<div class="docCat-head-txt text-truncate w-75">
				{{ pdfLink.name }}
			</div>
		</div>
		<div class="mobile-body app-bottom-padding p-0 overflow-x-hidden">
			<div class="thumbnail-grid px-3 mt-3">
				<template v-if="loading">
					<div
						class="thumbnailShimmer"
						v-for="n in 1"
						:key="'placeholder-' + n"
					>
						<b-skeleton width="100%" height="100%" />
					</div>
				</template>

				<template v-else>
					<div v-for="page in numPages" :key="page" class="thumbnail">
						<pdf :src="src" :page="page" :scale="0.3"></pdf>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import pdf from "vue-pdf";

export default {
	props: {
		pdfLink: Object,
	},
	data() {
		return {
			loading: true,
			src: null,
			numPages: 0,
		};
	},
	components: {
		pdf,
	},
	watch: {
		pdfLink: {
			immediate: true,
			handler(newVal) {
				if (newVal) {
					this.loadPdf(newVal.link);
				}
			},
		},
	},
	methods: {
		closeDocument() {
			this.$emit("showDoc", false);
			this.resetState();
		},
		resetState() {
			this.src = null;
			this.numPages = 0;
			this.$forceUpdate();
		},
		loadPdf(link) {
			// Create a loading task for the PDF
			const loadingTask = pdf.createLoadingTask(link);

			// Set the src to the loading task
			this.src = loadingTask;

			// Once the PDF is loaded, get the number of pages
			loadingTask.promise
				.then((pdfDoc) => {
					this.numPages = pdfDoc.numPages;
					this.loading = false; // Stop loading once pages are loaded
				})
				.catch((error) => {
					this.loading = false;
					throw new Error(error);
				});
		},
	},
	mounted() {
		if (this.pdfLink) {
			this.loadPdf(this.pdfLink.link);
		}
	},
};
</script>

<style>
.thumbnail-grid {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	justify-content: center;
}

.thumbnail-grid canvas {
	height: 100% !important;
}

.thumbnail {
	cursor: pointer;
	border: 1px solid #ccc;
	padding: 5px;
	box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.16);
	width: 100%;
}
.thumbnailShimmer {
	border: 1px solid #ccc;
	padding: 5px;
	box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.16);
	height: 550px;
	width: 300px;
}
</style>
